import { Train } from "lucide-react";
import { Link, useLocation } from "wouter";

import { getNavigationForRole } from "../lib/utils";

import { ROUTES } from "@/common/config";
import { useAuth, useUser } from "@/common/hooks";
import { cn } from "@/common/lib/utils";

import "./styles.css";

export function DesktopMenu() {
  const [location, setLocation] = useLocation();

  const {
    auth: { role },
  } = useAuth();
  const { permissions } = useUser();

  if (!role) return null;

  const navigationList = getNavigationForRole(role, permissions);

  return (
    // Desktop - версия, менее 768рх скрывается
    <div className="hidden md:flex">
      <nav
        className="w-60 shadow-sm flex flex-col"
        style={{ backgroundColor: "var(--color-background-white)" }}
      >
        {/* Logo Section */}
        <div className="px-4 py-5 border-b border-gray-200">
          <div
            onClick={() => setLocation(ROUTES.ROOT)}
            className="flex items-center justify-center cursor-pointer hover:opacity-80 transition-opacity mb-2"
          >
            <div className="mr-4 flex items-center justify-center">
              <img src="/logo-head.png" alt="ЭИС" className="h-20 object-contain" />
            </div>
            <div
              className={"hidden lg:block text-sm font-bold leading-3"}
              style={{ color: "var(--color-dasha-style)" }}
            >
              <div>Электронная</div> <div>Информационная</div> <div>Система</div>
            </div>
          </div>
          <p className="text-sm italic font-serif text-gray-600 leading-relaxed">
            Быстро, выгодно, безопасно
          </p>
        </div>

        {/* Spacing to position menu at "личный кабинет" level */}
        <div className="pt-8">
          <div className="p-4">
            <ul className="space-y-2">
              {navigationList.map((item) => {
                const Icon = item.icon;
                const isActive = location === item.href;

                return (
                  <li key={item.name}>
                    <Link href={item.href}>
                      <span
                        className={cn(
                          "flex items-center px-3 py-2 text-sm font-medium rounded-md transition-colors cursor-pointer",
                          isActive
                            ? "nav-active"
                            : item.href === ROUTES.CREATE_ORDER
                              ? "bg-orange-600 hover:bg-orange-700 text-white"
                              : "nav-item",
                        )}
                      >
                        <Icon className="h-5 w-5 mr-3" />
                        <span className="w-40">{item.name}</span>
                      </span>
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
}
